import {
  PhoneNumberSchema,
  PhoneNumberUseCase,
} from "@redotech/redo-model/phone/phone-number";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getPhoneNumberByTeamIdAndUseCase = {
  name: "getPhoneNumberByTeamIdAndUseCase" as const,
  input: z.object({
    teamId: z.string(),
    useCase: createEnum(PhoneNumberUseCase),
  }),
  output: PhoneNumberSchema.nullable(),
};
